import { get, getTrackingString } from '../../utils/object-helpers';

export default class {
    onInput(input) {
        const share = get(input, 'page.modules.SHARE_MODULE', null);
        const tracking = getTrackingString(share, 'shareAction.action.trackingList');
        return {
            label: get(share, 'text', ''),
            ariaLabel: get(share, 'shareAction.accessibilityText', ''),
            tracking,
            shareModel: {
                pageId: get(share, 'shareAction.action.params.pageId', '3418065'),
                storeUrlId: get(share, 'shareAction.action.params.storeUrlId', ''),
                categoryType: get(share, 'shareAction.action.params.categoryType', ''),
                categoryId: get(share, 'shareAction.action.params.categoryId', ''),
                enableSharedCheckmark: true,
                shareSectionTitle: get(share, 'shareAction.action.params.shareSectionTitle', ''),
                a11yCloseText: get(share, 'shareAction.action.params.a11yCloseText', ''),
                a11yMinimizeText: get(share, 'shareAction.action.params.a11yMinimizeText', ''),
                a11yMaximizeText: get(share, 'shareAction.action.params.a11yMaximizeText', ''),
                a11ySpinnerText: get(share, 'shareAction.action.params.a11ySpinnerText', ''),
                a11yAttentionText: get(share, 'shareAction.action.params.a11yAttentionText', ''),
                defaultErrorMessage: get(share, 'shareAction.action.params.defaultErrorMessage', '')
            }
        };
    }
}
